"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _public = require("@/api/public/public");
var _vuex = require("vuex");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  computed: _objectSpread({}, (0, _vuex.mapState)({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  })),
  data: function data() {
    return {
      backReason: "",
      registerDia: false,
      isBack: false,
      loading: false,
      actNum: 0,
      isEnter: true,
      loginDialog: false,
      opacity: "",
      codeImg: "",
      TEACHERLIST: [{
        name: "教学能力大赛",
        linkUrl: "/teacherIndex"
      }],
      userLogin: {
        userHd: require("@/assets/img/user.png"),
        username: "登录"
      },
      logo: require("@/assets/img/logo.png"),
      footerTxt: "",
      userMsg: {
        loginType: "0",
        username: "",
        password: "",
        verificationCode: "",
        keyId: ""
      },
      // 登录框规则
      userRules: {
        username: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }, {
          min: 1,
          max: 30,
          message: "长度在 1 到 30 个字符",
          trigger: "blur"
        }, {
          required: true,
          pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
          message: "账号不支持特殊字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }],
        verificationCode: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }, {
          min: 4,
          max: 4,
          message: "长度在 4 个字符",
          trigger: "blur"
        }]
      },
      loginLogo: "",
      scId: ""
    };
  },
  methods: {
    isback2022: function isback2022() {
      this.$router.push("/");
    },
    handleClose: function handleClose() {
      this.registerDia = false;
    },
    // 去修改
    toEdit: function toEdit() {
      this.registerDia = false;
      //  注册修改
      this.$router.push({
        path: "/registerEdit",
        query: {
          id: this.scId
        }
      });
    },
    // 获取导航
    // getNav() {
    //   navCode({
    //     param: this.prCode
    //   }).then(res => {
    //     this.navList = res.data;
    //   });
    // },
    // 显示登录弹出框
    isLogin: function isLogin() {
      this.getImgCode();
      this.loginDialog = true;
    },
    // 获取验证码
    getImgCode: function getImgCode() {
      var _this = this;
      if (this.userMsg.loginType == 1) {
        this.codeImg = "";
        this.codeImg = "https://jiangxi.icve.com.cn/dev-api/VerifyCode?ts=" + new Date();
      } else {
        (0, _public.getImgCode)().then(function (res) {
          _this.codeImg = "data:image/jpg;base64," + res.data.codeImage;
          _this.userMsg.keyId = res.data.keyId;
        });
      }
    },
    getCookie: function getCookie(key) {
      var cookies = document.cookie;
      if (cookies.length > 0) {
        var start = cookies.indexOf(key + "=");
        if (start < 0) {
          return "";
        }
        var end = cookies.indexOf(";", start);
        if (end < 0) {
          end = cookies.length;
        }
        return cookies.substring(start + key.length + 1, end);
      }
    },
    // 获取Mooc学院的验证码
    getMoocCode: function getMoocCode() {
      this.codeImg = "https://jiangxi.icve.com.cn/dev-api/VerifyCode?ts=" + new Date();
    },
    // 设置flag
    setFlag: function setFlag() {
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        var data = res.data;
        sessionStorage.setItem("book", JSON.stringify(data.expertAuthentication));
      });
    },
    // 登录
    login: function login(v) {
      var _this2 = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          if (_this2.userMsg.loginType == 1) {
            var users = {
              username: _this2.userMsg.username,
              password: _this2.userMsg.password
              // verifycode: this.userMsg.verificationCode
            };
            (0, _public.LoginMooc)(users).then(function (res) {
              window.open("https://mooc-old.icve.com.cn/design/course/courseOpenIndex.html");
            });
          } else {
            _this2.loading = true;
            var _users = {
              username: _this2.userMsg.username,
              password: _this2.$md5(_this2.userMsg.password),
              code: _this2.userMsg.verificationCode,
              keyId: _this2.userMsg.keyId,
              urlSign: _this2.prCode
            };
            _this2.$store.dispatch("user/login", _users).then(function (res) {
              _this2.scId = undefined;
              _this2.loading = false;
              _this2.$router.push({
                path: "/dashboard",
                naem: "Dashboard"
              });
              sessionStorage.setItem("isFlag", "true");
              _this2.$message.success("操作成功。");
              // this.setFlag();
            }).catch(function (e) {
              _this2.loading = false;
              _this2.$message.error("登录失败");
              if (_this2.prCode == "guizhou" && e.code === 10086) {
                _this2.loginDialog = false;
                _this2.registerDia = true;
                _this2.backReason = e.msg;
                _this2.scId = e.data;
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 前往后台
    backToHt: function backToHt() {
      this.$router.push({
        path: "/ht/dashboard",
        name: "Dashboard"
      });
    },
    // 获取网站标题logo,文字描述
    getWebLogo: function getWebLogo() {
      var _this3 = this;
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        if (res.code === 2000) {
          var data = res.data;
          _this3.logo = data.webLogo;
          _this3.footerTxt = data.footer;
          _this3.loginLogo = data.loginLogo;
        }
      });
    }
  },
  watch: {
    "$route.path": function $routePath(newVal, oldVal) {
      if (newVal === "/") {
        this.opacity = true;
      } else {
        this.opacity = false;
      }
    },
    "userMsg.loginType": function userMsgLoginType(n, o) {
      var _this4 = this;
      if (n == 1) {
        this.getMoocCode();
      } else {
        (0, _public.getImgCode)().then(function (res) {
          _this4.codeImg = "data:image/jpg;base64," + res.data.codeImage;
          _this4.userMsg.keyId = res.data.keyId;
        });
      }
    }
  },
  created: function created() {
    // this.getWebLogo();
    var v = this.$route.path;
    if (v === "/") {
      this.opacity = true;
    } else {
      this.opacity = false;
    }
    // 获取导航
    // this.getNav();
    // 本地存储导航样式下标
    sessionStorage.setItem("actNum", this.actNum);
    // 判断状态
    var e = sessionStorage.getItem("info");
    if (e) {
      this.isBack = true;
      // this.userLogin.userHd = JSON.parse(e).avatarUrl;
    } else {
      this.isBack = false;
    }
  }
};